import React from 'react';
import "./NavBar.css";
import './CartProduct.css';
// import deleteIcon from '../Icons/ph_x-bold.png';
const CartProduct = ({ProductName, Price, ImageUrl, showDeleteButton = true}) => {
    // const [quantity, setQuantity] = useState(1); // Initialize quantity state

    // // Function to handle decrementing quantity
    // const handleDecrement = () => {
    //     if (quantity > 1) { // Ensure quantity doesn't go below 1
    //         setQuantity(quantity - 1);
    //     }
    // };

    // // Function to handle incrementing quantity
    // const handleIncrement = () => {
    //     setQuantity(quantity + 1);
    // };

    const handleDelete = () => {
        // Retrieve the current cart from local storage
        const currentCart = JSON.parse(localStorage.getItem('cart')) || [];

        // Filter out the product to be deleted from the cart based on its product_name
        const updatedCart = currentCart.filter(product => product.product_name !== ProductName);

        // Update the cart in local storage
        localStorage.setItem('cart', JSON.stringify(updatedCart));

        // Reload the page or update state to reflect changes
        window.location.reload();
    };

    return (
        <div class="parent">
            {/* <div class="brand-name">Brand Name</div> */}
            <div className="cart-item">
                {/* <img src={deleteIcon} alt="Delete" className="delete-icon" /> */}
                <div class="cart-info">
                    <img src={ImageUrl} alt="Delete" className="product-icon" />
                    <div class="frame-53">
                        <div class="frame-52">
                            <text class="product-name">
                                {ProductName}
                            </text>
                            <div className="quantity-controls">
                                {showDeleteButton && <button onClick={handleDelete}>delete</button>}
                                {/* <span className="quantity">{quantity}</span>
                                <button onClick={handleIncrement}>+</button> */}
                            </div>
                        </div>
                        <text class="price">
                            ${Price}
                        </text>

                    </div>
                </div>
            </div>
            
        </div >
    );
};

export default CartProduct;
